import React from "react";
import { Link } from "react-router-dom";
import withContentFallback from "../../utils/withContentFallback";
import LinkLabel from "../shared/LinkLabel";
import { heroContent } from "../../constants/homePageContent";
import "./Hero.css";

const Hero = ({ content }) => {
  const {
    heading,
    subheading,
    paragraphText,
    buttonText,
    buttonLink,
    secondaryButtonText,
    secondaryButtonLink,
  } = content; // Wrap the component with withContentFallback HOC

  return (
    <section className="hero">
      {/* Real <img> (not a CSS background) so it is discovered early and can
          carry fetchpriority. Same URLs are preloaded in public/index.html. */}
      <picture>
        <source
          media="(max-width: 768px)"
          srcSet={`${process.env.PUBLIC_URL}/images/hero-mobile.webp`}
          type="image/webp"
        />
        <img
          className="hero-bg"
          src={`${process.env.PUBLIC_URL}/images/hero-1600.webp`}
          alt=""
          width="1600"
          height="1067"
          fetchPriority="high"
        />
      </picture>
      <div className="hero-overlay"></div>
      <div className="hero-content">
        <h1>{heading}</h1>
        <h2>{subheading}</h2>
        <p>{paragraphText}</p>
        <div className="hero-buttons">
          <Link to={buttonLink} className="btn btn-primary">
            <LinkLabel about="Shamshersons">{buttonText}</LinkLabel>
          </Link>
          <Link to={secondaryButtonLink} className="btn btn-secondary">
            <LinkLabel about="Shamshersons">{secondaryButtonText}</LinkLabel>
          </Link>
        </div>
      </div>
    </section>
  );
};

// Wrap the component with withContentFallback HOC
export default withContentFallback(Hero, heroContent);
